import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import { createBrowserHistory } from "history";
import UserDetailsComp from "./component";
import { useParams } from "react-router-dom";

const CouponDeatilsContainer = (props) => {


// Example usage




  const { couponid } = useParams();
  
    const [details, setBasicDetails] = useState();
    const [loading, setLoading] = useState(true)
    

    useEffect(()=>{
        LoadBasicDetails()
    },[])
   
    const LoadBasicDetails = () => {
        return props.getDataFromAPI(
          `/partner/api/v1/coupon/fetchCoupon/${couponid}`,
          "GET",
          undefined,
          (response) => {
            setLoading(false)
            setBasicDetails(response);
            // console.log("response---------> details11", response);
           
          },
          (err) => {},
          true
        );
      };
  return (
    <UserDetailsComp
 coupon={details}
 loading={loading}
   /> 

  )
}

function mapStateToProps({ props }) {
    return {
      props,
    };
  }
  export default connect(mapStateToProps, {
    getDataFromAPI,
  })(CouponDeatilsContainer);
